import { useContext } from 'react'

import { ComponentValidationContext } from '../context'

export const useComponentValidationProvider = () =>
  useContext(ComponentValidationContext)
